import { render, staticRenderFns } from "./wastePerGuestPerServiceTime.vue?vue&type=template&id=4edcb782"
import script from "./wastePerGuestPerServiceTime.js?vue&type=script&lang=js&external"
export * from "./wastePerGuestPerServiceTime.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports